/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateAdditionalInsuredDto = {
    /**
     * ID of the additional insured (required for updates, omit for new)
     */
    id?: string;
    /**
     * Title (MR, MRS, MS, DOCTOR, etc. — uppercase Ando values)
     */
    title?: string;
    /**
     * First name (required when creating new)
     */
    firstName?: string;
    /**
     * Last name (required when creating new)
     */
    lastName?: string;
    /**
     * Date of birth (required when creating new)
     */
    dob?: string;
    /**
     * Gender (required when creating new)
     */
    gender?: UpdateAdditionalInsuredDto.gender;
    /**
     * Preferred name
     */
    preferredName?: string;
    /**
     * Email address
     */
    email?: string;
    /**
     * Preferred phone type
     */
    preferredPhone?: UpdateAdditionalInsuredDto.preferredPhone;
    /**
     * Mobile phone number
     */
    mobile?: string;
    /**
     * Home phone number
     */
    homePhone?: string;
    /**
     * Work phone number
     */
    workPhone?: string;
    /**
     * Relationship to the client
     */
    relationship?: UpdateAdditionalInsuredDto.relationship;
};
export namespace UpdateAdditionalInsuredDto {
    /**
     * Gender (required when creating new)
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Preferred phone type
     */
    export enum preferredPhone {
        MOBILE = 'MOBILE',
        HOME = 'HOME',
        WORK = 'WORK',
    }
    /**
     * Relationship to the client
     */
    export enum relationship {
        PARTNER_SPOUSE = 'PARTNER_SPOUSE',
        PARENT = 'PARENT',
        CHILD = 'CHILD',
        FRIEND = 'FRIEND',
        OTHER = 'OTHER',
        POLICY_OWNER = 'POLICY_OWNER',
        BUSINESS_PARTNER = 'BUSINESS_PARTNER',
        SIBLING = 'SIBLING',
    }
}

